import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import { setLoading, showAuth, authPage } from "../Redux/action";
import { encrypt } from "../Admin/crypto";
import apiRequest from "../apiCall";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router";

const Signup = () => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showSendOTP, setShowSendOTP] = useState(false);
  const navigate = useNavigate()
  const errorsz = () => toast.error("Internal Sever Error, Please try again later.");

  const initialValues = {
    firstname: "",
    lastname: "",
    mobile: "",
    password: "",
    email: "",
  };

  const validationSchema = yup.object({
    firstname: yup.string().required("Please enter a First Name"),
    lastname: yup.string().required("Please enter a Last Name"),
    mobile: yup
      .string()
      .required("Please enter a Mobile number")
      .matches(/^\d{10}$/, "Mobile number must be a 10-digit number"),

    password: yup
      .string()
      .required("Please enter a password")
      .min(8, "Please enter at least 8 characters"),
    email: yup
      .string()
      .email("Please enter a valid email address")
      .required("Please enter an email address"),
    OTP: yup.string().when('showSendOTP', {
      is: true,
      then: yup.string().required("Please enter OTP"),
    }),
  });

  const { values, errors, handleSubmit, handleChange, setFieldError, setFieldValue } = useFormik({
    initialValues,
    validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
    //   const formData = new FormData();
      const formData = { ...values, password: encrypt(values.password) }
      // formData.append("content", JSON.stringify(values1));
      
      try {
        dispatch(setLoading(true));
        const res = await apiRequest("POST", "signup", formData, false, false);
        
        if (res.status === 200 && res.isPresent === 0 ) {
          dispatch(setLoading(false));
          setShowSendOTP(true);
        } else if (res.status === 200 && res.isPresent === 1 ) {
          dispatch(setLoading(false));
          toast.error("Mobile number is already present. Please Login!");
          dispatch(authPage("login"));
        } else {
          dispatch(setLoading(false));
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          dispatch(setLoading(false));
        } else {
          dispatch(setLoading(false));
          setFieldError("field", "message");
        }
      }
    },
  });
  

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("userToken");
    setIsLoggedIn(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleOTPSubmit = async () => {
    try {
      dispatch(setLoading(true));
      const otpRes = await apiRequest("POST","validateOTP", {
        mobile: values.mobile,
        OTP: values.OTP},false, false);
      if (otpRes.mes === "FOUND") {
        dispatch(setLoading(false));
        toast.success("Your account has been successfully created. Please Login!");
        navigate("/")
      //   setTimeout(() => {
      //     dispatch(showAuth(false));
      // }, 2000);

      setTimeout(() => {
        
        dispatch(showAuth(true));
        dispatch(authPage("login"));
      }, 1000);

      } else {
        dispatch(setLoading(false));
        toast.error(otpRes.message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      errorsz();
      console.log("Error validating OTP:", error);
    }
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      if (!showSendOTP) {
        handleSubmit();
      } else {
        handleOTPSubmit();
      }
    }
  };

  return isLoggedIn ? (
    <>
      <div className="auth">
        <div className="modal-content">
          <h2>Logout</h2>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </>
  ) : (
    <>
      {!showSendOTP ? (
        <div className="auth">
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <button
              style={{
                cursor: "pointer",
                fontSize: "20px",
                width: "31px",
                padding: "0px",
                marginTop: "0px",
                marginLeft: "auto", // Push the button to the right
              }}
              className="delete-cart"
              onClick={() => dispatch(showAuth(false))}
            >
              <b>X</b>
            </button>
          </div>
          <h2>Sign up</h2>
          <p>Please enter your details</p>
          <input
            type="text"
            placeholder="First Name"
            onKeyDown={handleKeyDown}
            onChange={handleChange("firstname")}
          />
          {errors.firstname && <div className="err">{errors.firstname}</div>}
          <input
            type="text"
            placeholder="Last Name"
            onKeyDown={handleKeyDown}
            onChange={handleChange("lastname")}
          />
          {errors.lastname && <div className="err">{errors.lastname}</div>}
          <input
            type="text"
            placeholder="Mobile Number"
            maxLength={10}
            onKeyDown={handleKeyDown}
            onChange={handleChange("mobile")}
          />
          {errors.mobile && <div className="err">{errors.mobile}</div>}

          <input
            type="text"
            placeholder="Email ID"
            onKeyDown={handleKeyDown}
            onChange={handleChange("email")}
          />
          {errors.email && <div className="err">{errors.email}</div>}
          <input
            type="Password"
            placeholder="Password"
            onChange={handleChange("password")}
            onKeyDown={handleKeyDown}
            maxLength={15}
            minLength={8}
          />
          {errors.password && <div className="err">{errors.password}</div>}
          {errorMessage && <div className="err">{errorMessage}</div>}
          <button onClick={handleSubmit}>Sign up</button>
          <div className="bottom-text">
            Already have an account?{" "}
            <span className="auth-link" onClick={() => dispatch(authPage("login"))}>Log in</span>
          </div>
        </div>
      ) : (
        <div className="auth">
          <p> Please enter your OTP</p>
          <input
            type="number"
            placeholder="OTP"
            onChange={(e) => setFieldValue("OTP", e.target.value)}
            onKeyPress={handleEnterKeyPress}
          />
          {errors.OTP && <div className="err">{errors.OTP}</div>}
          <button onClick={handleOTPSubmit}>Submit</button>
        </div>
      )}
      <Toaster position="top-right" />
    </>
  );
};

export default Signup;
